$(document).ready(function()
{

    if ($(".social-sharing").length) 
    {
        $( '.social-sharing a.external' ).click(function( e )
        {
            e.preventDefault();
            m40_socialShare( this.href, 640, 480 );
        });
        window.m40_socialShare = function(url, winWidth, winHeight) {
            var winTop = (window.innerHeight / 2) - (winHeight / 2);
            var winLeft = (window.innerWidth / 2) - (winWidth / 2);
            window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            return false;
        };
    }
    
});